<template>
  <router-view />
</template>

<script>
export default {
  name: "AccountMain",
};
</script>

<style></style>
